export default "__VITE_ASSET__Dsy0qk3Q__"